import { notify } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from 'react-query'

import { useCurrentUser } from '@modules-deprecated/app/user/currentUserContext'
import { updateUser } from '@modules-deprecated/app/user/query-api'

import { NotificationKeys } from '../../../../../../../enums/notificationKeys'
import { QueryKeys } from '../../../../../../../enums/queryKeys'
import { OnboardingForm } from '../../../../../types/onboardingForm'

export const useSubmitNamePhoneStepForm = () => {
  const { t } = useTranslation()
  const { user } = useCurrentUser()
  const queryClient = useQueryClient()
  const { isLoading: isSubmitting, mutateAsync } = useMutation(updateUser)

  const submitForm = useCallback(
    async (values: OnboardingForm) => {
      if (!user) {
        return
      }

      const { name, phone } = values
      const hasNameChanged = name !== user.name
      const hasPhoneChanged = phone !== user.phone

      if (!hasNameChanged && !hasPhoneChanged) {
        return
      }

      try {
        await mutateAsync({ id: user.id, name, phone })
        queryClient.invalidateQueries(QueryKeys.CurrentUser)
      } catch (error) {
        notify({
          id: NotificationKeys.OnboardingStepSubmitError,
          message: t('error_saving'),
          variant: 'error',
        })
        throw error
      }
    },
    [mutateAsync, queryClient, t, user],
  )

  return {
    isSubmitting,
    submitForm,
  }
}
